import {
  generateRequest,
  Action,
} from '.';

export const getUserPreferences = () => generateRequest({
  method: 'GET',
  endpoint: '/preferences',
  credentials: 'same-origin',
  types: [
    Action.Preferences.GetPending,
    Action.Preferences.GetCompleted,
    Action.Preferences.GetFailed,
  ],
});

export const updateUserPreferences = body => generateRequest({
  method: 'POST',
  endpoint: '/preferences',
  credentials: 'same-origin',
  body,
  types: [
    Action.Preferences.UpdatePending,
    Action.Preferences.UpdateCompleted,
    Action.Preferences.UpdateFailed,
  ],
});
